export var SwiperUtils;
(function (SwiperUtils) {
    let Config;
    (function (Config) {
        /** standard set of options for swipers */
        Config.defaults = () => ({
            centerInsufficientSlides: true,
            watchOverflow: true,
            speed: 300,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 6,
            },
        });
        /** autoplay swipers */
        Config.autoplay = (delayTime = 2000) => ({
            autoplay: {
                delay: delayTime,
                disableOnInteraction: true,
            },
        });
        /** add pagination bullets and navigation buttons */
        Config.navigation = (variant = 'black') => ({
            pagination: {
                el: `.swiper-pagination${variant === 'black' ? '.swiper-pagination-black' : ''}`,
                type: 'bullets',
                dynamicBullets: true,
                clickable: true,
            },
            navigation: {
                nextEl: `.swiper-button-next${variant === 'black' ? '.swiper-button-black' : ''}`,
                prevEl: `.swiper-button-prev${variant === 'black' ? '.swiper-button-black' : ''}`,
            },
        });
        /** set the slides per view on a swiper, and set breakpoints based on screen width */
        Config.perView = (defaultPerView, breakpoints) => ({
            slidesPerView: Math.max(defaultPerView, 1),
            slidesPerGroup: Math.max(defaultPerView - 1, 1),
            ...(breakpoints && {
                breakpoints: Object.keys(breakpoints).reduce((output, key) => ({
                    ...output,
                    [key]: {
                        slidesPerView: Math.max(breakpoints[key], 1),
                        slidesPerGroup: Math.max(breakpoints[key] - 1, 1),
                    },
                }), {}),
            }),
        });
    })(Config = SwiperUtils.Config || (SwiperUtils.Config = {}));
})(SwiperUtils || (SwiperUtils = {}));
